import { FC } from 'react';
import {
  Container,
  Inner,
  StepWrapper,
  ClickableBox,
  TopRow,
  LeftConnector,
  RightConnector,
  Circle,
  StyledCheckIcon,
  ActiveDot,
  Label,
  Description,
} from './OrderStepper.styles';

interface OrderStepperProps {
  activeStep: number;
  onStepClick: (step: number) => void;
}

const steps = [
  {
    label: 'Customer Information',
    description: 'Basic order and delivery details',
  },
  {
    label: 'Order Items',
    description: 'Products included in this order',
  },
  {
    label: 'Discounts',
    description: 'Optional price adjustment',
  },
  {
    label: 'Surcharges',
    description: 'Additional costs',
  },
  {
    label: 'Summary',
    description: 'Order Summary & Confirmation',
  },
];

const OrderStepper: FC<OrderStepperProps> = ({ activeStep, onStepClick }) => {
  const isCompleted = (index: number) => index < activeStep;
  const isActive = (index: number) => index === activeStep;
  const isInactive = (index: number) => index > activeStep;

  return (
    <Container>
      <Inner>
        {steps.map((step, index) => (
          <StepWrapper key={index}>
            <ClickableBox
              onClick={() => index <= activeStep && onStepClick(index)}
              isCompleted={isCompleted(index)}
              isActive={isActive(index)}
              isInactive={isInactive(index)}
              isClickable={index <= activeStep}
            >
              <TopRow>
                {index > 0 && <LeftConnector isActive={index <= activeStep} />}
                {index < steps.length - 1 && (
                  <RightConnector isActive={index < activeStep} />
                )}
                <Circle
                  isCompleted={isCompleted(index)}
                  isActive={isActive(index)}
                >
                  {isCompleted(index) ? (
                    <StyledCheckIcon />
                  ) : isActive(index) ? (
                    <ActiveDot />
                  ) : null}
                </Circle>
              </TopRow>
              <Label
                isCompleted={isCompleted(index)}
                isActive={isActive(index)}
              >
                {step.label}
              </Label>
              <Description>{step.description}</Description>
            </ClickableBox>
          </StepWrapper>
        ))}
      </Inner>
    </Container>
  );
};

export default OrderStepper;
